<template>
  <div class="tenant-modifier">
    <select
      v-if="isAdmin"
      class="form-select"
      :class="{ 'is-invalid': !isTenantSelected }"
      id="changeTenant"
      v-model="tenant"
      @change="setTenant"
    >
      <option value="" disabled>Select Tenant...</option>
      <option v-for="t in userTenants" :key="t.identifier" :value="t.identifier">
        {{ t.name }} {{ t.inactive ? "(inactive)" : "" }}
      </option>
    </select>
    <input
      v-else
      class="form-control"
      :class="{ 'is-invalid': !isTenantSelected }"
      type="text"
      placeholder="Change Tenant"
      id="changeTenant"
      v-model="tenant"
      @change="setTenant"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { routesNames } from '@/core/constants'

export default {
  mounted() {},
  data() {
    return {
      tenant: ''
    }
  },
  created() {
    this.getUserTenants()
    // Restore the dropdown selection from the persisted store context so a page
    // refresh does not make an active tenant appear unselected.
    if (this.currentTenant) {
      this.tenant = this.currentTenant
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'userTenants', 'currentTenant']),
    isTenantSelected() {
      if (!this.tenant) return false
      if (!this.userTenants || this.userTenants.length === 0) return false
      return this.userTenants.some(t => t.identifier === this.tenant)
    }
  },
  watch: {
    // Keep the local selection in sync if the tenant context changes elsewhere.
    currentTenant(value) {
      this.tenant = value || ''
    },
    // When tenants load, reset dropdown if current value is not a valid option.
    userTenants(tenants) {
      if (this.tenant && tenants.length && !tenants.some(t => t.identifier === this.tenant)) {
        this.tenant = ''
        this.$store.commit('setCurrentTenant', '')
      }
    }
  },
  methods: {
    getUserTenants() {
      this.$store.dispatch('getUserTenants')
    },
    setTenant() {
      if (this.tenant !== '') {
        this.$store.commit('setCurrentTenant', this.tenant)
      }
      this.getData()
    },
    getData() {
      if (this.$route.name === routesNames.auditLogs) {
        this.$store.dispatch('getAuditLogs')
        return
      }

      if (this.$route.name === routesNames.history) {
        this.$store.dispatch('getHistoryRecords')
        return
      }

      this.$store.dispatch('getEditorData')
    }
  }
}
</script>

<style scoped>
button {
  margin: 5px;
}

.tenant-modifier {
  display: inline-block;
  margin: 5px;
}

.tenant-warning {
  font-size: 0.8rem;
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/TenantModifier.vue